import { cn } from "@/lib/utils";

interface BadgeProps {
	className?: string;
	children: React.ReactNode;
	variant?: "default" | "secondary" | "outline" | "destructive";
}

export function Badge({ className, children, variant: _variant = "default" }: BadgeProps) {
	return (
		<span
			className={cn(
				"inline-flex items-center rounded-md border border-border px-2 py-0.5 text-xs font-medium",
				className,
			)}
		>
			{children}
		</span>
	);
}
